export const defaultFilter = () => {
    return {
        company_id: null,
        slq_location_id: null,
        type: null,
        page: 1,
        per_page: 10,
        date_report: null,
        in_use: null,
    };
};

/**
 * Datos por defecto de los cancerígenos.
 *
 * @returns {Object}
 */
export const defaultCancerogenicData = () => {
    return {
        totals: {
            total: 0,
            is_cancerogenic: 0,
            not_cancerogenic: 0,
            group_1: 0,
            group_2a: 0,
            group_2b: 0,
            report_fds: 0,
        },
        component_count: {},
    };
}

// Filtros y paginación
export const defaultParamsFilter = () => {
    return {
        fields: [
            {
                key: "product",
                label: "Producto",
                sortable: true,
                thStyle: {
                    "background-color": "#3787e17a !important",
                    "width": "350px",
                    "min-width": "150px"
                },
            },
            {
                key: "state",
                label: "Estado",
                sortable: true,
                thStyle: {
                    "background-color": "#3787e17a !important",
                    "min-width": "80px",
                    "max-width": "80px",
                    "text-align": 'center'
                },
            },
            {
                key: "manufacturer",
                label: "Fabricante",
                sortable: true,
                thStyle: {
                    "background-color": "#3787e17a !important",
                    "width": "350px",
                    "min-width": "150px"
                },
            },
            {
                key: "locations",
                label: "Ubicaciones",
                sortable: false,
                thStyle: {
                    "background-color": "#3787e17a !important",
                },
            }
        ],
        items: [],
        data: {
            total: 0,
        },
        paginate: 1,
        page: 1,
        per_page: 10
    };
};

export default {
    showGraphics: false,
    dataGraphics: [],
    dataGraphics_2: [],
    dataGraphics_3: [],
    dataGraphics_4: [],
    dataGraphics_5: [],
    total_pay: 0,
    totales: {
        totalTanks: 0,
        mercDanger: 0,
        pqNotDangers: 0,
    },
    fullscreenActive: false,
    graphicScreenActive: "general",
    dataCancerogenic: defaultCancerogenicData(),
    filter: defaultFilter(),
    detailsProducts: defaultParamsFilter(),

    // Toxicidad Acumulada - Por mes en rango de un año
    accumulatedToxicityGraph: [],
    accumulatedProductDetails: [],
    accumulatedShowProductsDetails: false,

    // Toxicidad aguda
    acuteToxicity: [],
    acuteToxicityShowProductsDetails: false,
    acuteToxicityLoadingShowProductsDetails: false,
    acuteToxicityProductDetails: [],
    filterGroups: [],
};
